import React from "react"

const FooterBanner = () => (
	<div style={{ textAlign: 'center', marginTop: 'var(--single)', marginBottom: 'var(--single)', maxWidth: "100%"  }}>
		<div data-fuse="22969287385"></div>
		</div>
)
export default FooterBanner
